import React, { useState, useEffect } from "react";
import { useSurveySrv } from "./useSurveySrv";
import { useSurveyAdapterMicrosite } from "./useSurveyAdapterMicrosite";
import { clearLocalStore } from "helpers/localStoreSrv";
import { Survey } from "hlscomponents";
import { useUiState } from "helpers/useUiState";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LANGUAGES, getLanguageId } from "./../../constants/supported_lang";
import { portalActions } from "store/portal-slice";
import { useSelector } from "react-redux";
import ReactGA from "react-ga";
import whitelabelConfig from "@whitelabel-config";
import { useSurveyAdapterMemeberPortal } from "./useSurveyAdapterMemeberPortal";
import { useTranslation } from "react-i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import BrandColors from "@brand-colors";
import { Modal, theme } from "antd";
import { set } from "cypress/types/lodash";
import { usePageTitle } from "helpers/usePageTitle";
import { useSessionDetailLog } from "helpers/useSessionDetailLog";
const { useToken } = theme;
const SurveyPage = (surveyid: any) => {
  const location = useLocation();
  const [isHover, setIsHover] = useState(false);
  const { token } = useToken();
  const { preferredLanguage } = location.state || {};
  console.log("preferredLanguage", preferredLanguage);
  interface SurveyData {
    surveyID: string;
    surveyCode: string;
    surveyDisplayName: string;
    surveyDescription: string;
    surveyDuration: string;
    surveyPages?: any[];
  }
  const { t } = useTranslation();
  usePageTitle("SURVEY_PAGE.PAGE_TITLE", `Survey - ${process.env.REACT_APP_PRODUCT}`);
  const { isAppLoading } = useUiState();
  const [surveyData, setSurveyData] = useState({});
  console.log("preferredLanguage", preferredLanguage);
  const [currentLanguage, setCurrentLanguage] = useState(preferredLanguage);
  const [cachedJSON, setCachedJSON] = useState<any[]>([]);
  const [PatientActivityDetailID, setPatientActivityDetailID] = useState("");
  const {
    getSurevyData,
    submitSurveyData,
    partialSurveyData,
    memberPortalsubmitSurveyData,
    partialSurveyDataRulebased,
    submitUploadDocument,
    deleteDocument,
    getLanguageTranslations,
    lastSeenPageNumberData,
  } = useSurveySrv();
  const { parseFromSource, parseToSource } = useSurveyAdapterMicrosite();
  const {
    parseFromSource: parseFromSourceMemberPortal,
    parseToSource: parseToSourceMemberPortal,
  } = useSurveyAdapterMemeberPortal();
  const navigate = useNavigate();
  const { logSessionDetail } = useSessionDetailLog();
  
  const appUiState = useSelector((state: any) => state.portal.uiState);
  const [isRuleBasedSurvey, setIsRuleBasedSurvey] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const dispatch = useDispatch();
  const [patientActivityID, setPatientActivityID] = useState(null);
  const [lastseenPageNumberVal, setLastseenPageNumberVal] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingSubmitData, setPendingSubmitData] = useState<any>(null);
  const [isSinglePageSurvey, setIsSinglePageSurvey] = useState(false);
  const [isPartialSaveEnabled, setIsPartialSaveEnabled] = useState(false);
  const styles = {
    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      borderRadius: "50px",
      textTransform: "uppercase",
      fontWeight: "500",
      boxShadow: "none",
    },
  };
  const handleDataFromChild = async (fileList: any) => {
    if (fileList.uid) {
      const formData = new FormData();
      formData.append("file", fileList);
      formData.append("PatientActivityDetailID", PatientActivityDetailID);

      try {
        await submitUploadDocument(formData);
      } catch (e) {
        handleErrorNavigation(e, navigate, t);
      }
    }
  };

  const handleDelete = async (id: any) => {
    if (id) {
      isAppLoading(true);
      try {
        await deleteDocument(id);
        setRefreshKey((prev) => prev + 1);
      } catch (e: any) {
        handleErrorNavigation(e, navigate, t);
      } finally {
        isAppLoading(false);
      }
    }
  };
  const getQuestions = (
    data: any,
    languageCode: any,
    langData: any,
    rawData: any,
    isRuleBased: boolean,
  ) => {
    const surveyData = data;
    let sortedQuestionData = surveyData.PatientActivityDetails.sort(
      (a: { QuestionNumber: number }, b: { QuestionNumber: number }) =>
        a.QuestionNumber > b.QuestionNumber ? 1 : -1,
    );
    sortedQuestionData = JSON.stringify(surveyData, null, sortedQuestionData);
    sortedQuestionData = JSON.parse(sortedQuestionData);

    const updatedSurveyData = updateQuestionsByLang(
      sortedQuestionData,
      languageCode,
      langData,
      rawData,
      isRuleBased,
    );
    sortedQuestionData.PatientActivityDetails = updatedSurveyData;
    (async () => {
      let parsedSurveyData;
      if (surveyData.IsRuleBasedSurvey == true) {
        let data = await proceedRuleBasedSurvey(sortedQuestionData);
        console.log("data--", data);
        setIsRuleBasedSurvey(true);
        parsedSurveyData = await parseFromSourceMemberPortal(data);
        console.log("parsedSurveyData", parsedSurveyData);
        parsedSurveyData.pages.forEach((pg: any) => {
          pg.questionGroups.forEach((group: any) => {
            group.questions.forEach((q: any) => {
              if ((q.questionType === 120000001 || q.questionType === 120000010) && q.response) {
              const { selectionType = "Multiple" } = q.AdditionalSetting ? JSON.parse(q.AdditionalSetting) : {};
                if (selectionType === "Multiple") {
                  if (!Array.isArray(q.response.length)) {
                    let fieldDelimiter = q.fielddelimiter
                      ? q.fielddelimiter
                      : "|";
                    q.response = q.response[0]?.value
                      .split(fieldDelimiter)
                      .map((choice: string) => choice.trim());
                  }
                }
              }
            });
          });
        });
      } else {
        let data = await proceedHrsSurvey(sortedQuestionData);
        parsedSurveyData = await parseFromSource(data);
        parsedSurveyData.pages.forEach((pg: any) => {
          pg.questionGroups.forEach((group: any) => {
            group.questions.forEach((q: any) => {
              if ((q.questionType === 120000001 ||q.questionType === 120000010 )&& q.response) {
                const { selectionType = "Multiple" } = q.AdditionalSetting ? JSON.parse(q.AdditionalSetting) : {};
                if (selectionType === "Multiple") {
                  if (!Array.isArray(q.response.length)) {
                    let fieldDelimiter = q.fielddelimiter
                      ? q.fielddelimiter
                      : "|";
                    q.response = q.response
                      .split(fieldDelimiter)
                      .map((choice: string) => choice.trim());
                  }
              }}
            });
          });
        });
        setIsRuleBasedSurvey(false);
      }
      setSurveyData(parsedSurveyData);
    })();
  };
  const updateQuestionsByLang = (
    data: any,
    languageCode: any,
    langData: any,
    rawData: any,
    isRuleBased: boolean,
  ) => {
    const updatedJson =
      langData?.filter((item: any) => item.LanguageCode === languageCode) || [];
    const engDataJson =
      langData?.filter((item: any) => item.LanguageCode === 120000000) || [];
    const updatedSurveyData = data.PatientActivityDetails.map((detail: any) => {
      if (rawData) {
        const testData = rawData.surveyPages;
        const correspondingQuestion = testData!
          .flatMap((page: any) => page.surveyQuestions)
          .find(
            (question: any) => question.questionCode === detail.QuestionCode,
          );

        if (correspondingQuestion && correspondingQuestion.ChoicesTextCode) {
          detail.ChoicesTextCode = correspondingQuestion.ChoicesTextCode;
          detail.QuestionTextCode = correspondingQuestion.QuestionTextCode;
          detail.SectionName = correspondingQuestion.SectionName;
          detail.SubSectionName = correspondingQuestion.SubSectionName;
          detail.NoneOfTheAboveText = correspondingQuestion.NoneOfTheAboveText;
          detail.NoneOfTheAboveTextCode =
            correspondingQuestion.NoneOfTheAboveTextCode;
          detail.IsNoneOfTheAboveEnabled =
            correspondingQuestion.IsNoneOfTheAboveEnabled;
        } else {
          detail.ChoicesTextCode = "Q7CH";
          detail.QuestionTextCode = "Q7";
        }
      }
      const englishChoicesMatch = engDataJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.ChoicesTextCode,
      );
      if (englishChoicesMatch && englishChoicesMatch.TextValue) {
        detail.EnglishChoice = englishChoicesMatch.TextValue.split(
          detail.FieldDelimiter,
        );
      }
      const questionMatch = updatedJson.find(
        (item: any) => item.TextCode === detail.QuestionTextCode,
      );

      if (questionMatch) {
        detail.Question = questionMatch.TextValue;
      }
      const englishQuestionMatch = engDataJson.find(
        (item: any) => item.TextCode === detail.QuestionTextCode,
      );

      if (englishQuestionMatch) {
        detail.EnglishQuestion = englishQuestionMatch.TextValue;
      }
      const enableChildMatch = updatedJson.find(
        (item: any) => item.TextCode === detail.EnableChildOnResponseCode,
      );

      if (enableChildMatch) {
        detail.EnableChildOnResponse = enableChildMatch.TextValue;
      }

      const choicesMatch = updatedJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.ChoicesTextCode,
      );
      if (choicesMatch && choicesMatch.TextValue) {
        if(isRuleBased){
          detail.Choices = [choicesMatch.TextValue];
        } else{
          detail.Choices = choicesMatch.TextValue.split(detail.FieldDelimiter);
        }
      }
      if (detail.IsNoneOfTheAboveEnabled) {
        const noneOfTheAboveTextMatch = updatedJson.find(
          (item: { TextCode: any }) =>
            item.TextCode === detail.NoneOfTheAboveTextCode,
        );
        if (noneOfTheAboveTextMatch) {
          detail.NoneOfTheAboveText = noneOfTheAboveTextMatch.TextValue;
        }
      }

      let responseData = detail?.Response?.split(detail.FieldDelimiter).map(
        (item: any) => item.trim(),
      );
      if (
        detail.IsNoneOfTheAboveEnabled &&
        responseData?.includes(detail?.NoneOfTheAboveText)
      ) {
        const noneOfTheAboveTextMatchEnglish = engDataJson.find(
          (item: { TextCode: any }) =>
            item.TextCode === detail.NoneOfTheAboveTextCode,
        );

        if (noneOfTheAboveTextMatchEnglish) {
          detail.EnglishResponse = noneOfTheAboveTextMatchEnglish.TextValue;
        }
      }
      const sectionMatch = updatedJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.SectionName,
      );
      if (sectionMatch) {
        detail.SectionName = sectionMatch.TextValue;
      }

      const subSectionMatch = updatedJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.SubSectionName,
      );
      if (subSectionMatch) {
        detail.SubSectionName = subSectionMatch.TextValue;
      }
      return detail;
    });
    return updatedSurveyData;
  };
  const getIdByCode = (code: string) => {
    const language = LANGUAGES.find((lang) => lang.code === code);
    return language?.id || null;
  };
  useEffect(() => {
    setCurrentLanguage(appUiState?.Language);
  }, [appUiState]);

  const formatMultichoiceResponse = (response: any) => {
    let finalResponse =
      response !== null && response !== undefined
        ? Array.isArray(response)
          ? response
          : [response]
        : response;

    var parsedRes = Array.isArray(finalResponse)
      ? finalResponse.map((res: any) => {
          if (res && typeof res === "string") {
            return {
              label: res.trim(),
              Index: res.trim(),
              value: res.trim(),
              Selected: true,
            };
          } else {
            return {
              label: "",
              Index: "",
              value: "",
              Selected: false,
            };
          }
        })
      : [];

    return parsedRes;
  };

  const proceedRuleBasedSurvey = async (obj: any) => {
    try {
      let data = await fetch(obj.SurveyUrl).then((res) => {
        return res.json();
      });
      let pgm = data;
      pgm["patientId"] = obj.PatientID;
      pgm["surveyID"] = obj.PatientActivityID;
      pgm["PatientActivityName"] = obj.PatientActivityName;
      pgm["IsRuleBasedSurvey"] = obj.IsRuleBasedSurvey;
      pgm["StartDate"] = obj.StartDate;
      pgm["IsPartialSaveEnabled"] = obj.IsPartialSaveEnabled;
      pgm["ResponseLanguage"] = obj.ResponseLanguage;
      pgm["LastUpdatedPageNumber"] = obj.LastUpdatedPageNumber || 0;
      const activityDetails = obj.PatientActivityDetails;
      const activityMap: any = {};
      activityDetails.forEach((detail: any) => {
        activityMap[detail.QuestionCode] = {
          PatientActivityDetailID: detail.PatientActivityDetailID,
          Response: detail.Response || null,
          Question: detail.Question,
          Choices: detail.Choices,
          ResponseCode: detail.ResponseCode,
          SectionName: detail.SectionName,
          SubSectionName: detail.SubSectionName,
          EnglishChoice: detail.EnglishChoice,
          NoneOfTheAboveText: detail.NoneOfTheAboveText,
          OtherResponse: detail.OtherResponse,
        };
      });

      if (pgm["surveyPages"] && Array.isArray(pgm["surveyPages"])) {
        pgm["surveyPages"].forEach((page: any) => {
          if (page.surveyQuestions && Array.isArray(page.surveyQuestions)) {
            page.surveyQuestions.forEach((question: any) => {
              const activityDetail = activityMap[question.questionCode];
              if (activityDetail) {
                const choicesArray =
                  activityDetail?.Choices[0]?.split("|") || [];
                const formattedChoices = question.surveyQuestionChoices.map(
                  (choice: any, index: any) => ({
                    choiceCode: choice.choiceCode,
                    choiceText: choicesArray[index] ?? "",
                    choiceTextInDefaultLanguage:
                      choice.choiceTextInDefaultLanguage,
                    scoringValue: 0,
                    isDefault: false,
                    choiceOrder: index + 1,
                  }),
                );
                question.surveyQuestionChoices = formattedChoices;
                question.questionText = activityDetail.Question;
                question.EnglishChoice = activityDetail.EnglishChoice;
                question.OthersResponse = activityDetail.OtherResponse;
                if (question.questionType === 120000001 || question.questionType === 120000010) {
                  question.PatientActivityDetailID =
                    activityDetail.PatientActivityDetailID;
                  question.Response = formatMultichoiceResponse(
                    activityDetail.Response,
                  );
                  question.SectionName = activityDetail.SectionName;
                  question.SubSectionName = activityDetail.SubSectionName;
                  question.NoneOfTheAboveText =
                    activityDetail.NoneOfTheAboveText;
                } else {
                  question.PatientActivityDetailID =
                    activityDetail.PatientActivityDetailID;
                  question.Response = activityDetail.Response;
                  question.ResponseCode = activityDetail.ResponseCode;
                  question.SectionName = activityDetail.SectionName;
                  question.SubSectionName = activityDetail.SubSectionName;
                }
              }
            });
          }
        });
        return pgm;
      }
    } catch (error) {
      handleErrorNavigation(error, navigate, t);
    }
  };

  const proceedHrsSurvey = async (obj: SurveyData): Promise<SurveyData> => {
    const processedObj = JSON.parse(JSON.stringify(obj));
    try {
      processedObj.PatientActivityDetails =
        processedObj.PatientActivityDetails.map((question: any) => {
          const formattedChoices = question.Choices.map(
            (choiceText: any, index: number) => ({
              choiceCode: question.AnswerCodes[index],
              choiceText,
              choiceTextInDefaultLanguage: choiceText,
              scoringValue: 0,
              isDefault: false,
              choiceOrder: index + 1,
            }),
          );
          const formattedChoicesEnglish = question.EnglishChoice.map(
            (choiceText: any, index: number) => ({
              choiceCode: question.AnswerCodes[index],
              choiceText,
              choiceTextInDefaultLanguage: choiceText,
              scoringValue: 0,
              isDefault: false,
              choiceOrder: index + 1,
            }),
          );
          return {
            ...question,
            Choices: formattedChoices,
            EnglishChoice: formattedChoicesEnglish,
  //             InformationType: question.InformationType ?? null,
  // InformationText: question.InformationText ?? null,
          };
        });
      return processedObj;
    } catch (error) {
      handleErrorNavigation(error, navigate, t);
      console.error("Error processing survey:", error);
      return obj;
    }
  };

  useEffect(() => {
    let isComponentMounted = true;

    const fetchAllData = async () => {
      try {
        isAppLoading(true);
        const surveyRes = await getSurevyData();
        const responseData = surveyRes?.data;
        setIsSinglePageSurvey(responseData?.IsSinglePageSurvey === true);
        setPatientActivityID(responseData.PatientActivityID);
        setLastseenPageNumberVal(responseData.LastseenPageNumber);
        setIsPartialSaveEnabled(responseData.IsPartialSaveEnabled === true);
        setIsRuleBasedSurvey(responseData.IsRuleBasedSurvey);
        let rawData = null;
        if (responseData.IsRuleBasedSurvey) {
          const rawDataResponse = await fetch(responseData.SurveyUrl);
          rawData = await rawDataResponse.json();
        }
        const filteredDetails = responseData?.PatientActivityDetails?.filter(
          (detail: any) => detail.QuestionType === 120000008,
        );

        if (isComponentMounted) {
          setPatientActivityDetailID(
            filteredDetails[0]?.PatientActivityDetailID,
          );
        }
        const languageRes = await getLanguageTranslations(
          responseData.TranslationGroupID,
          getLanguageId(preferredLanguage),
        );
        if (isComponentMounted) {
          setCachedJSON(languageRes.data || null);
          localStorage.setItem(
            "languageData",
            JSON.stringify(languageRes.data),
          );
          if (responseData) {
            const langCode = getIdByCode(currentLanguage);
            getQuestions(responseData, langCode, languageRes.data, rawData, responseData.IsRuleBasedSurvey);
          }
          isAppLoading(false);
        }
      } catch (error) {
        if (isComponentMounted) {
          console.error("Error fetching data or TranslationGroupID", error);
          isAppLoading(false);
          clearLocalStore();
          handleErrorNavigation(error, navigate, t);
        }
      }
    };

    fetchAllData();
    return () => {
      isComponentMounted = false;
    };
  }, [refreshKey, currentLanguage]);
  console.log("currentLanguage....", currentLanguage);
  const actualSurveySubmitHandler = async (updatedSurveyData: any) => {
    let parseData: {};
    let submitSurvey;
    if (isRuleBasedSurvey) {
      parseData = await parseToSourceMemberPortal(updatedSurveyData,isPartialSaveEnabled);
      submitSurvey = memberPortalsubmitSurveyData;
      isAppLoading(true);
      await submitSurvey(parseData)
        ?.then((res) => {
          isAppLoading(false);
          dispatch(portalActions.submitFormData(parseData));
          setTimeout(() => {
            navigate("/thankyourulebased", { replace: true });
          }, 100);

          ReactGA.event({
            category: "Submit Button Click ",
            action: "Survey Submitted Successfully",
            label: "Survey Page",
          });
        })
        .catch((e) => {
          isAppLoading(false);
          console.log(e);
          ReactGA.event({
            category: "Submit Button Click ",
            action: "Survey Submitted Unsuccessfully",
            label: "Survey Page",
          });
          clearLocalStore();
          handleErrorNavigation(e, navigate, t);
        });
    } else {
      parseData = await parseToSource(updatedSurveyData,isPartialSaveEnabled );
      submitSurvey = submitSurveyData;
      isAppLoading(true);
      await submitSurvey(parseData)
        ?.then((res) => {
          isAppLoading(false);
          setTimeout(() => {
            navigate("/thankyou");
          }, 100);

          ReactGA.event({
            category: "Submit Button Click ",
            action: "Survey Submitted Successfully",
            label: "Survey Page",
          });
        })
        .catch((e) => {
          isAppLoading(false);
          console.log(e);
          ReactGA.event({
            category: "Submit Button Click ",
            action: "Survey Submitted Unsuccessfully",
            label: "Survey Page",
          });
          clearLocalStore();
          handleErrorNavigation(e, navigate, t);
        });
    }
  };
  const onPartialSaveSubmitHandler = async (partialSaveData: any) => {
    const parseData = surveyData?.IsRuleBasedSurvey
      ? await parseToSourceMemberPortal(partialSaveData, true)
      : await parseToSource(partialSaveData, true);
    try {
      surveyData?.IsRuleBasedSurvey
        ? await partialSurveyDataRulebased(parseData)
        : await partialSurveyData(parseData);
      ReactGA.event({
        category: "Submit Button Click ",
        action: "Survey Submitted Successfully",
        label: "Survey Page",
      });
    } catch (e) {
      isAppLoading(false);
      console.log(e);
      ReactGA.event({
        category: "Submit Button Click ",
        action: "Survey Submitted Unsuccessfully",
        label: "Survey Page",
      });
      clearLocalStore();
      handleErrorNavigation(e, navigate, t);
    }
  };
    const surveySubmitHandler = async (updatedSurveyData: any) => {
      console.log("isSinglePageSurvey",isSinglePageSurvey);
    const singlePageSurvey = isSinglePageSurvey;
  if (singlePageSurvey) {
    setPendingSubmitData(updatedSurveyData);
    setShowConfirmModal(true);
    return;
  }

  await actualSurveySubmitHandler(updatedSurveyData);
};
  const lastPageSeenNumberHandler = async (lastVisitPageData: any) => {
    let lastVisitPageDataPlus = lastVisitPageData + 1;
    logSessionDetail("SurveyPageViewed", { pageNumber: lastVisitPageDataPlus });
    if (lastseenPageNumberVal < lastVisitPageDataPlus) {
      try {
        await lastSeenPageNumberData(lastVisitPageDataPlus, patientActivityID);
      } catch (e) {
        isAppLoading(false);
        console.log(e);
        clearLocalStore();
        handleErrorNavigation(e, navigate, t);
      }
    }
  };
  return (
    <div data-testid="survey-page">
      <Survey
        surveyData={surveyData}
        onSubmit={surveySubmitHandler}
        onSaveProgress={() => {}}
        onPartialSaveSubmit={onPartialSaveSubmitHandler}
        lastPageSeenNumber={lastPageSeenNumberHandler}
        onSendData={handleDataFromChild}
        onDeleteData={handleDelete}
        appLanguage={
          appUiState && appUiState.Language ? appUiState.Language : "en"
        }
        rightAlignedLanguage={whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          appUiState.Language,
        )}
        size={"md"}
        primaryColor={BrandColors.BUTTON_BG}
        isChildQuestionVisible={
          whitelabelConfig.uiSettings.isChildQuestionVisible
        }
      />
      <Modal
       title= {t("GLOBAL.CONFIRM_SUBMISSION")}
        open={showConfirmModal}
        onOk={async () => {
          setShowConfirmModal(false);
          if (pendingSubmitData) {
            await actualSurveySubmitHandler(pendingSubmitData);
            setPendingSubmitData(null);
          }
        }}
        onCancel={() => {
          setShowConfirmModal(false);
          setPendingSubmitData(null);
        }}
       okText={t("GLOBAL.AGREE")}   // Agree
  cancelText={t("GLOBAL.CANCEL")}      // Cancel
        okButtonProps={{
          style: styles.button, //  reuse your existing style
        }}
         cancelButtonProps={{
          style: styles.button, //  reuse your existing style
        }}
      >
        <p>{t("GLOBAL.SUBMIT_CONFIRM_TEXT")}</p>
      </Modal>
    </div>
  );
};
export default SurveyPage;
